export const dataSchema = {
  getEntitySchema: {
    actions: {},
    interfaces: []
  }
};
export const propsSchema = {
  itemsPerRow: {}
};
export const defaultProps = 'id,name';
//# sourceMappingURL=constants.js.map